import React from "react";
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from "recharts";
import { GetLightpointData } from "../hooks/middleware.js";
import { CountItems, SortItems, GetTopItems, CountTotal } from "../hooks/chartMethods.js";

const COLORS = ["#f76e24", "#ff9e59", "#ffb380", "#ffd1a3", "#ffe6cc"];

export default function TileTopLightsources({ id }) {
  const { data, error } = GetLightpointData(id);
  const counts = CountItems(data, "lampcurtypename");
  const sorted = SortItems(counts, "count");
  const finalData = GetTopItems(sorted, 5, "Others");
  const totalCount = CountTotal(finalData, "count");

  if (error) return <p>Error loading data.</p>;
  if (!finalData) return <p>Loading Pie Chart...</p>;
  if (finalData.length === 0) return <p>No data found</p>;

  return (
    <div style={{ display: "flex", gap: "0rem" }}>
      <div style={{ minWidth: "200px" }}>
        {finalData.map((item, index) => (
          <div key={item.name} className="table-row">
            <span
              style={{
                display: "inline-block",
                width: "12px",
                height: "12px",
                backgroundColor: COLORS[index % COLORS.length],
                marginRight: "0.5rem",
                borderRadius: "2px",
              }}
            ></span>
            <span
              style={{
                minWidth: "100px",
                maxWidth: "100px",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
              title={item.name}
            >
              {item.name}
            </span>
            <span style={{ minWidth: "80px", textAlign: "right" }}>
              {((item.count / totalCount) * 100).toFixed(1)}%
            </span>
          </div>
        ))}
      </div>

      <div style={{ flex: 1, height: 200 }}>
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={finalData}
              dataKey="count"
              nameKey="name"
              cx="50%"
              cy="50%"
              outerRadius={100}
              label={false}
            >
              {finalData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
              ))}
            </Pie>
            <Tooltip />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}
